<template>
  <div class="approvalCenter">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    />

    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :button-list="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :custom-visible="false"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left" />
        <vxe-table-column
          v-for="(item, index) in columns"
          :key="index"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.prop"
          :title="item.label"
        />
      </sirui-table>
    </div>
  </div>
</template>
<script>
  import tableMixins from '@/common/mixins/table.js';
  import API from '@/api/systemManage/approvalCenter.js';

  export default {
    name: 'approvalCenter',
    components: {},
    mixins: [tableMixins],
    data() {
      return {
        load: false,
        query: {
          processType: '',
          businessNo: '',
          approvalResult: '',
          gmtCreateStart: '',
          gmtCreateEnd: '',
        },
        applicationList: [],
        menuButtonList: [],
        tableData: [],
        multipleSelection: [],
        businessIdList: [],
      };
    },
    computed: {
      // 搜索字段
      searchColumns() {
        return [
          {
            // 审批流程类型
            prop: 'processType',
            name: this.$t('approval.table.processType'),
            type: 'dict',
            dictType: 'process_type',
          },
          {
            // 业务编码
            prop: 'businessNo',
            name: this.$t('approval.search.businessNo'),
            type: 'input',
          },
          {
            // 状态名
            prop: 'approvalResult',
            name: this.$t('approval.table.approvaResultName'),
            type: 'select',
            options: [
              { value: '0', label: '审批驳回' },
              { value: '1', label: '审批通过' },
              { value: '2', label: '待审批' },
            ],
          },
          {
            // 创建时间从
            name: '创建时间从',
            prop: 'gmtCreateStart',
            type: 'startDaterangePickerTime',
          },
          {
            // 创建时间到
            name: '创建时间到',
            prop: 'gmtCreateEnd',
            type: 'endDaterangePickerTime',
          },
        ];
      },
      // 表格显示字段
      columns() {
        return [
          { prop: 'processTypeName', label: this.$t('approval.table.processType') },
          {
            prop: 'businessNo',
            label: this.$t('approval.table.businessNo'),
          },
          { prop: 'approvalResultName', label: this.$t('approval.table.approvaResultName') },
          // { prop: 'approvaResult', label: this.$t('approval.table.approvaResult') },
          { prop: 'businessId', label: this.$t('approval.table.businessId') },
          { prop: 'gmtCreate', label: this.$t('approval.table.gmtCreate') },
        ];
      },
    },
    /** 页面必要代码Start */
    mounted() {
      this.$nextTick(() => {
        this.getButtonList();
        this.getData();
      });
    },
    methods: {
      // 获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
        });
      },
      // 获取数据
      getData() {
        this.load = true;
        const query = this.$refs.siruiSearch.query;
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        this.$axios.post(API.GET_LIST_API, query).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 点击按钮触发的方法
      chooseClick(type) {
        /*if (this.multipleSelection.length !== 1) {
            this.$message({
            showClose: true,
            message: this.$t('approval.message.chooseOne'),
            type: 'error'
            })
            return
      }*/
        if (this.multipleSelection[0].approvalResultName != '待审批') {
          this.$message({
            showClose: true,
            message: this.$t('approval.message.choose'),
            type: 'error',
          });
          return;
        }
        if (type === 'approvalPass') {
          this.getApproval(1);
        } else if (type === 'approvalNoPass') {
          this.getApproval(0);
        }
      },

      //审批
      getApproval(type) {
        const arr = [];
        const idType = {};
        this.multipleSelection.forEach((item) => {
          arr.push(item.businessId);
          idType[item.businessId] = item.processType;
        });
        const params = {
          approvalResult: type,
          businessIdList: arr,
          idType: idType,
        };
        this.load = true;
        this.$axios.post(API.GET_APPROVAL_API, params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.getData();
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
    },
  };
</script>
